import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import AiVideoList from './AiVideoList';

export default {
    list: AiVideoList,
    icon: VideoLibraryIcon,
};
